import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from '../lib/cx'

export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx('card', className)} {...rest} />
}

export interface CardHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  actions?: ReactNode
}

export function CardHeader({ title, actions, className, ...rest }: CardHeaderProps) {
  return (
    <div className={cx('card-hd', className)} {...rest}>
      <h2>{title}</h2>
      {actions && <div className="row">{actions}</div>}
    </div>
  )
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx('card-body', className)} {...rest} />
}

export interface StatProps {
  label: ReactNode
  value: ReactNode
  hint?: ReactNode
  className?: string
}

/** Indicateur chiffré (valeur en Montserrat, libellé mono). */
export function Stat({ label, value, hint, className }: StatProps) {
  return (
    <div className={cx('card stat', className)}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {hint && <div className="stat-hint">{hint}</div>}
    </div>
  )
}

export function StatGrid({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx('stat-grid', className)} {...rest} />
}
